import { useEffect, useRef } from "react";
import "../assets/styles/scroll-progress.scss";

function ScrollProgress() {
  const barRef = useRef(null);

  useEffect(() => {
    let ticking = false;

    function update() {
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? (window.scrollY / docHeight) * 100 : 0;
      if (barRef.current) {
        barRef.current.style.width = `${Math.min(progress, 100)}%`;
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }

    update();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);

  return (
    <div className="scroll-progress">
      <div ref={barRef} className="scroll-progress__bar" />
    </div>
  );
}

export default ScrollProgress;
